import { Stack } from 'expo-router';
import React from 'react';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import { useShouldShowDesktopNavigation } from 'shared/hooks/useShouldShowDesktopNavigation';

function BorrowingPowerLayoutWeb() {
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  return shouldShowDesktopNavigation ? (
    <DesktopNavigation>
      <Stack />
    </DesktopNavigation>
  ) : (
    <Stack />
  );
}

export default BorrowingPowerLayoutWeb;
